import { VerifiedStarIcon } from 'tt-ui-lib/icons';
import styles from './UserInfoItem.module.scss';

const UserInfoItem = ({ Icon, iconWidth, iconHeight, text, isConfirmed, userProps }) => (
  <>
    {text === 'Phone number' ? (
      userProps && userProps.tel !== null ? (
        <div className={styles.itemWrapper}>
          <div className={styles.iconWrapper}>
            <Icon style={{ width: iconWidth, height: iconHeight }} />
          </div>
          <div className={styles.text}>{text}</div>
          <div className={styles.iconWrapper}>
            {text === 'Email address' && isConfirmed && (
              <VerifiedStarIcon className="icon-green-fill" style={{ width: 18, height: 18 }} />
            )}
          </div>
        </div>
      ) : null
    ) : (
      <div className={styles.itemWrapper}>
        <div className={styles.iconWrapper}>
          <Icon style={{ width: iconWidth, height: iconHeight }} />
        </div>
        <div className={styles.text}>{text}</div>
        <div className={styles.iconWrapper}>
          {text === 'Email address' && isConfirmed && (
            <VerifiedStarIcon className="icon-green-fill" style={{ width: 18, height: 18 }} />
          )}
        </div>
      </div>
    )}
  </>
);

export default UserInfoItem;
